import BN from "bn.js";
import Decimal from "decimal.js";
import { TIME } from "@bridgesplit/utils";
import { WhirlpoolOffchain } from "@bridgesplit/abf-sdk";

export type YieldData = {
    positionYieldOverTvl24h: number;
    positionYieldOverTvlAnnual: number;
    positionUsdValue: number;
};

export enum YieldPeriodSelection {
    DAILY = "daily",
    ANNUAL = "annual"
}

export function getPositionYield({
    positionLiquidity,
    poolLiquidity,
    whirlpoolOffchain,
    positionUsdValue,
    positionTickUpper,
    positionTickLower
}: {
    positionUsdValue: number;
    positionLiquidity: BN;
    positionTickUpper: number;
    positionTickLower: number;
    poolLiquidity: BN;
    whirlpoolOffchain: WhirlpoolOffchain;
}): YieldData {
    // if position is out of range, return 0
    if (
        positionTickUpper < whirlpoolOffchain.tickCurrentIndex ||
        positionTickLower > whirlpoolOffchain.tickCurrentIndex
    ) {
        return { positionYieldOverTvl24h: 0, positionYieldOverTvlAnnual: 0, positionUsdValue };
    }

    const liquidityShare = new Decimal(positionLiquidity.toString()).div(poolLiquidity.toString()).toNumber();

    const positionYield = liquidityShare * parseFloat(whirlpoolOffchain.stats["24h"].fees);
    const positionYieldOverTvl24h = positionYield / positionUsdValue;
    const positionYieldOverTvlAnnual = positionYieldOverTvl24h * (TIME.YEAR / TIME.DAY);

    return { positionYieldOverTvl24h, positionYieldOverTvlAnnual, positionUsdValue };
}
